export default "__VITE_ASSET__Dx4K1nG$__"